import * as K from './OperatorsConstants';
import Fuse from 'fuse.js';

import floopback from 'lib/floopback';
var Operators = new floopback('operators');

export function find(params) {
  let _this = this;
  return (dispatch, getState) => {
    dispatch({
      type: K.FIND,
      payload: Operators.find(params),
    }).then(function (result) {
      _this.searchTable(getState().Operators.search);
    });
  };
}

export function findById(id) {
  return (dispatch, getState) => {
    dispatch({
      type: K.FIND_BY_ID,
      payload: Operators.findById(id),
    });
  };
}

export function create(formData) {
  return (dispatch, getState) => {
    return new Promise(function (resolve, reject) {
      dispatch({ type: K.CREATE + '_PENDING', payload: formData });
      Operators.create(formData)
        .then(function (data) {
          dispatch({ type: K.CREATE + '_FULFILLED', payload: data });
          resolve(data);
        })
        .catch(function (error) {
          dispatch({ type: K.CREATE + '_REJECTED', payload: error });
          reject(error);
        });
    });
  };
}

export function update(id, formData) {
  return (dispatch, getState) => {
    return new Promise(function (resolve, reject) {
      dispatch({ type: K.UPDATE + '_PENDING', payload: formData });
      Operators.update(id, formData)
        .then(function (data) {
          dispatch({ type: K.UPDATE + '_FULFILLED', payload: data });
          resolve(data);
        })
        .catch(function (error) {
          dispatch({ type: K.UPDATE + '_REJECTED', payload: error });
          reject(error);
        });
    });
  };
}

export function remove(id) {
  return (dispatch, getState) => {
    return new Promise(function (resolve, reject) {
      dispatch({ type: K.DELETE + '_PENDING' });
      Operators.delete(id)
        .then(function (data) {
          dispatch({ type: K.DELETE + '_FULFILLED', payload: data });
          resolve(data);
        })
        .catch(function (error) {
          dispatch({ type: K.DELETE + '_REJECTED', payload: error });
          reject(error);
        });
    });
  };
}

export function changeTable(feature, value) {
  return (dispatch, getState) => {
    dispatch({
      type: K.CHANGE_TABLE,
      payload: {
        feature: feature,
        value: value,
      },
    });
  };
}

export function searchTable(search) {
  return (dispatch, getState) => {
    var options = {
      threshold: 0.4,
      location: 0,
      distance: 100,
      maxPatternLength: 32,
      minMatchCharLength: 1,
      keys: ['name', 'website', 'phone'],
    };
	
    const filteredData = getState().Operators.data.filter(
      (operator) => operator.isDeleted !== true
    );

    var fuse = new Fuse(filteredData, options);
    let result = fuse.search(search);

    dispatch({
      type: K.SEARCH_TABLE,
      payload: {
        search: search,
        searchData: result,
      },
    });
  };
}



// WEBPACK FOOTER //
// ./src/views/Operators/redux/OperatorsActions.jsx